<template>
  <!-- Modal -->
  <Modal :showModal="isModalOpen" @close="closeModal">
    <template #header>
      <h5><span v-html="modalTitle"></span></h5>
    </template>
    <template #body>
      <img class="modal__img" :src="modalContent" />
    </template>
  </Modal>

  <!-- Content -->
  <div class="cards">
    <div v-for="image in images" :key="image.name" class="card">
      <div class="card__title">
        <span v-html="image.name"></span>
      </div>
      <div class="card__content">
        <div class="card__img">
          <img
            v-on:click="openModal(image.url, image.name)"
            :src="image.url"
            :title="image.name"
            :alt="image.name"
            :onerror="
              `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
            "
            :broken="
              `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
            "
          />
        </div>
        <p>
          <span v-html="image.description"></span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Modal from "@/components/common/Modal.vue";
export default {
  components: {
    Modal,
  },
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    const basePath_images = process.env.VUE_APP_TEST_IMAGE;
    const currentDate = new Date().getTime();
    return {
      basePath,
      basePath_images,
      currentDate,
    };
  },
  data() {
    return {
      modalTitle: "",
      modalContent: "",
      isModalOpen: false,
      image: null,
      images: [
        {
          name: "Irradiancia global – OC (W m<sup>-2</sup>)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_global_OC_BSRN.webp",
          description:
            "La irradiancia global de onda corta (W m<sup>-2</sup>) es la irradiancia solar total que incide sobre una superficie horizontal. Se compone de la irradiancia directe y de la irradiancia difusa.",
        },
        {
          name: "Irradiancia directa – OC (W m<sup>-2</sup>)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_directa_OC_BSRN.webp",
          description:
            "La irradiancia solar que incide directamente sobre la superficie de la Tierra se denomina irradiancia directa de onda corta (W m<sup>-2</sup>). La irradiancia difusa es otra de las componentes de la irradiancia global.",
        },
        {
          name: "Irradiancia difusa – OC (W m<sup>-2</sup>)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_difusa_OC_BSRN.webp",
          description:
            "La irradiancia solar indirecta se denomina irradiancia difusa de onda corta (W m-2). El término 'difuso' significa que la luz llega irregularmente dispersa y sin una dirección uniforme. La irradiancia difusa es una de las componentes de la irradiancia global.",
        },
        {
          name: "Irradiancia emitida – OL (W m<sup>-2</sup>)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_incidente_OL_BSRN.webp",
          description:
            " La irradiancia de onda larga emiitida (W m<sup>-2</sup>) es la irradiancia que emite la superficie y depende de la temperatura y de la emisividad de los elementos que conforman la superficie terrestre.",
        },
        {
          name: "Irradiancia incidente – OL (W m<sup>-2</sup>)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_emitida_OL_BSRN.webp",
          description:
            "La irradiancia de onda larga incidente (W m<sup>-2</sup>) es la irradiancia que emite la atmósfera y las nubes y depende de la temperatura y de la emisividad de los componetes atmosféricos y las nubes.",
        },
        {
          name: "Irradiancia neta (W m<sup>-2</sup>)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_neta_irrad_BSRN.webp",
          description:
            "La irradiancia neta (W m<sup>-2</sup>) es la suma de todas las componentes de irradiancid de onda corta y onda larga. Representa el límite de energía disponible para los procesos de intercambio de energia superficial.",
        },
      ],
    };
  },
  methods: {
    openModal(img, title) {
      this.modalTitle = title;
      this.modalContent = img;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.image-background {
  display: flex;
  justify-content: center;
}
img {
  cursor: pointer;
}
.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
}

@media (max-width: 768px) {
  .cards {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

.card {
  border: 1px solid #ccc;
  border-radius: 5px;
}

.card__title {
  background-color: #0099ff;
  color: white;
  padding: 0.5em;
  text-align: center;
}

.card__btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0099ff;
  color: white;
  border-radius: 100%;
  opacity: 0.5;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.card__img {
  overflow: hidden;
  padding-top: 0.8rem;
}
.card__img > img:hover {
  scale: 105%;
  transition-duration: 200ms;
  transition-property: scale;
  transition-timing-function: ease-in-out;
}

.card__content > p {
  padding: 0.5em;
}

.modal__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
</style>
